/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_descriptor_pb = require('google-protobuf/google/protobuf/descriptor_pb.js');
goog.exportSymbol('proto.DecimalMaxOption', null, global);
goog.exportSymbol('proto.DecimalMinOption', null, global);
goog.exportSymbol('proto.DigitsOption', null, global);
goog.exportSymbol('proto.EntityOption', null, global);
goog.exportSymbol('proto.EntityOption.Kind', null, global);
goog.exportSymbol('proto.EntityOption.Visibility', null, global);
goog.exportSymbol('proto.GoesOption', null, global);
goog.exportSymbol('proto.IfInvalidOption', null, global);
goog.exportSymbol('proto.IfMissingOption', null, global);
goog.exportSymbol('proto.MaxOption', null, global);
goog.exportSymbol('proto.MinOption', null, global);
goog.exportSymbol('proto.PatternOption', null, global);
goog.exportSymbol('proto.Time', null, global);
goog.exportSymbol('proto.TimeOption', null, global);
goog.exportSymbol('proto.beta', null, global);
goog.exportSymbol('proto.betaAll', null, global);
goog.exportSymbol('proto.betaType', null, global);
goog.exportSymbol('proto.by', null, global);
goog.exportSymbol('proto.decimalMax', null, global);
goog.exportSymbol('proto.decimalMin', null, global);
goog.exportSymbol('proto.defaultMessage', null, global);
goog.exportSymbol('proto.digits', null, global);
goog.exportSymbol('proto.enrichment', null, global);
goog.exportSymbol('proto.enrichmentFor', null, global);
goog.exportSymbol('proto.entity', null, global);
goog.exportSymbol('proto.events', null, global);
goog.exportSymbol('proto.everyIs', null, global);
goog.exportSymbol('proto.experimental', null, global);
goog.exportSymbol('proto.experimentalAll', null, global);
goog.exportSymbol('proto.experimentalType', null, global);
goog.exportSymbol('proto.goes', null, global);
goog.exportSymbol('proto.ifInvalid', null, global);
goog.exportSymbol('proto.ifMissing', null, global);
goog.exportSymbol('proto.internal', null, global);
goog.exportSymbol('proto.internalAll', null, global);
goog.exportSymbol('proto.internalType', null, global);
goog.exportSymbol('proto.is', null, global);
goog.exportSymbol('proto.max', null, global);
goog.exportSymbol('proto.min', null, global);
goog.exportSymbol('proto.pattern', null, global);
goog.exportSymbol('proto.rejections', null, global);
goog.exportSymbol('proto.required', null, global);
goog.exportSymbol('proto.requiredField', null, global);
goog.exportSymbol('proto.spi', null, global);
goog.exportSymbol('proto.spiAll', null, global);
goog.exportSymbol('proto.spiService', null, global);
goog.exportSymbol('proto.spiType', null, global);
goog.exportSymbol('proto.typeUrlPrefix', null, global);
goog.exportSymbol('proto.valid', null, global);
goog.exportSymbol('proto.validationOf', null, global);
goog.exportSymbol('proto.when', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.IfMissingOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IfMissingOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.IfMissingOption.displayName = 'proto.IfMissingOption';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.IfMissingOption.prototype.toObject = function(opt_includeInstance) {
  return proto.IfMissingOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IfMissingOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IfMissingOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    msgFormat: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IfMissingOption}
 */
proto.IfMissingOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.IfMissingOption;
  return proto.IfMissingOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IfMissingOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IfMissingOption}
 */
proto.IfMissingOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgFormat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.IfMissingOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.IfMissingOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IfMissingOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IfMissingOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMsgFormat();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string msg_format = 1;
 * @return {string}
 */
proto.IfMissingOption.prototype.getMsgFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.IfMissingOption.prototype.setMsgFormat = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DecimalMinOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DecimalMinOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.DecimalMinOption.displayName = 'proto.DecimalMinOption';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DecimalMinOption.prototype.toObject = function(opt_includeInstance) {
  return proto.DecimalMinOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DecimalMinOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DecimalMinOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, ""),
    inclusive: jspb.Message.getFieldWithDefault(msg, 2, false),
    msgFormat: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DecimalMinOption}
 */
proto.DecimalMinOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DecimalMinOption;
  return proto.DecimalMinOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DecimalMinOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DecimalMinOption}
 */
proto.DecimalMinOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInclusive(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgFormat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DecimalMinOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DecimalMinOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DecimalMinOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DecimalMinOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInclusive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMsgFormat();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.DecimalMinOption.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.DecimalMinOption.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool inclusive = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.DecimalMinOption.prototype.getInclusive = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.DecimalMinOption.prototype.setInclusive = function(value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string msg_format = 3;
 * @return {string}
 */
proto.DecimalMinOption.prototype.getMsgFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.DecimalMinOption.prototype.setMsgFormat = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DecimalMaxOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DecimalMaxOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.DecimalMaxOption.displayName = 'proto.DecimalMaxOption';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DecimalMaxOption.prototype.toObject = function(opt_includeInstance) {
  return proto.DecimalMaxOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DecimalMaxOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DecimalMaxOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, ""),
    inclusive: jspb.Message.getFieldWithDefault(msg, 2, false),
    msgFormat: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DecimalMaxOption}
 */
proto.DecimalMaxOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DecimalMaxOption;
  return proto.DecimalMaxOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DecimalMaxOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DecimalMaxOption}
 */
proto.DecimalMaxOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInclusive(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgFormat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DecimalMaxOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DecimalMaxOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DecimalMaxOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DecimalMaxOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInclusive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMsgFormat();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.DecimalMaxOption.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.DecimalMaxOption.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool inclusive = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.DecimalMaxOption.prototype.getInclusive = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.DecimalMaxOption.prototype.setInclusive = function(value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string msg_format = 3;
 * @return {string}
 */
proto.DecimalMaxOption.prototype.getMsgFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.DecimalMaxOption.prototype.setMsgFormat = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MinOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MinOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.MinOption.displayName = 'proto.MinOption';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MinOption.prototype.toObject = function(opt_includeInstance) {
  return proto.MinOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MinOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MinOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, ""),
    msgFormat: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MinOption}
 */
proto.MinOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MinOption;
  return proto.MinOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MinOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MinOption}
 */
proto.MinOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgFormat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MinOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MinOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MinOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MinOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMsgFormat();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.MinOption.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.MinOption.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string msg_format = 2;
 * @return {string}
 */
proto.MinOption.prototype.getMsgFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.MinOption.prototype.setMsgFormat = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MaxOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MaxOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.MaxOption.displayName = 'proto.MaxOption';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MaxOption.prototype.toObject = function(opt_includeInstance) {
  return proto.MaxOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MaxOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MaxOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, ""),
    msgFormat: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MaxOption}
 */
proto.MaxOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MaxOption;
  return proto.MaxOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MaxOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MaxOption}
 */
proto.MaxOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgFormat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MaxOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MaxOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MaxOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MaxOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMsgFormat();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.MaxOption.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.MaxOption.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string msg_format = 2;
 * @return {string}
 */
proto.MaxOption.prototype.getMsgFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.MaxOption.prototype.setMsgFormat = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DigitsOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DigitsOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.DigitsOption.displayName = 'proto.DigitsOption';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DigitsOption.prototype.toObject = function(opt_includeInstance) {
  return proto.DigitsOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DigitsOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DigitsOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    integerMax: jspb.Message.getFieldWithDefault(msg, 1, 0),
    fractionMax: jspb.Message.getFieldWithDefault(msg, 2, 0),
    msgFormat: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DigitsOption}
 */
proto.DigitsOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DigitsOption;
  return proto.DigitsOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DigitsOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DigitsOption}
 */
proto.DigitsOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIntegerMax(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFractionMax(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgFormat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DigitsOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DigitsOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DigitsOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DigitsOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIntegerMax();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getFractionMax();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMsgFormat();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 integer_max = 1;
 * @return {number}
 */
proto.DigitsOption.prototype.getIntegerMax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.DigitsOption.prototype.setIntegerMax = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 fraction_max = 2;
 * @return {number}
 */
proto.DigitsOption.prototype.getFractionMax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.DigitsOption.prototype.setFractionMax = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string msg_format = 3;
 * @return {string}
 */
proto.DigitsOption.prototype.getMsgFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.DigitsOption.prototype.setMsgFormat = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.TimeOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.TimeOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.TimeOption.displayName = 'proto.TimeOption';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.TimeOption.prototype.toObject = function(opt_includeInstance) {
  return proto.TimeOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TimeOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TimeOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    pb_in: jspb.Message.getFieldWithDefault(msg, 1, 0),
    msgFormat: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TimeOption}
 */
proto.TimeOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.TimeOption;
  return proto.TimeOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TimeOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TimeOption}
 */
proto.TimeOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Time} */ (reader.readEnum());
      msg.setIn(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgFormat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.TimeOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.TimeOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TimeOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TimeOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIn();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMsgFormat();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Time in = 1;
 * @return {!proto.Time}
 */
proto.TimeOption.prototype.getIn = function() {
  return /** @type {!proto.Time} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.Time} value */
proto.TimeOption.prototype.setIn = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string msg_format = 2;
 * @return {string}
 */
proto.TimeOption.prototype.getMsgFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.TimeOption.prototype.setMsgFormat = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PatternOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PatternOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.PatternOption.displayName = 'proto.PatternOption';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PatternOption.prototype.toObject = function(opt_includeInstance) {
  return proto.PatternOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PatternOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PatternOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    regex: jspb.Message.getFieldWithDefault(msg, 1, ""),
    flag: jspb.Message.getFieldWithDefault(msg, 2, 0),
    msgFormat: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PatternOption}
 */
proto.PatternOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PatternOption;
  return proto.PatternOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PatternOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PatternOption}
 */
proto.PatternOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegex(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFlag(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgFormat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PatternOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PatternOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PatternOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PatternOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRegex();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFlag();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMsgFormat();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string regex = 1;
 * @return {string}
 */
proto.PatternOption.prototype.getRegex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.PatternOption.prototype.setRegex = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 flag = 2;
 * @return {number}
 */
proto.PatternOption.prototype.getFlag = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.PatternOption.prototype.setFlag = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string msg_format = 3;
 * @return {string}
 */
proto.PatternOption.prototype.getMsgFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.PatternOption.prototype.setMsgFormat = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.IfInvalidOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IfInvalidOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.IfInvalidOption.displayName = 'proto.IfInvalidOption';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.IfInvalidOption.prototype.toObject = function(opt_includeInstance) {
  return proto.IfInvalidOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IfInvalidOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IfInvalidOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    msgFormat: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IfInvalidOption}
 */
proto.IfInvalidOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.IfInvalidOption;
  return proto.IfInvalidOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IfInvalidOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IfInvalidOption}
 */
proto.IfInvalidOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgFormat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.IfInvalidOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.IfInvalidOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IfInvalidOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IfInvalidOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMsgFormat();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string msg_format = 1;
 * @return {string}
 */
proto.IfInvalidOption.prototype.getMsgFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.IfInvalidOption.prototype.setMsgFormat = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GoesOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.GoesOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.GoesOption.displayName = 'proto.GoesOption';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GoesOption.prototype.toObject = function(opt_includeInstance) {
  return proto.GoesOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GoesOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GoesOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    pb_with: jspb.Message.getFieldWithDefault(msg, 1, ""),
    msgFormat: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GoesOption}
 */
proto.GoesOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GoesOption;
  return proto.GoesOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GoesOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GoesOption}
 */
proto.GoesOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWith(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgFormat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GoesOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GoesOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GoesOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GoesOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWith();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMsgFormat();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string with = 1;
 * @return {string}
 */
proto.GoesOption.prototype.getWith = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.GoesOption.prototype.setWith = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string msg_format = 2;
 * @return {string}
 */
proto.GoesOption.prototype.getMsgFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.GoesOption.prototype.setMsgFormat = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.EntityOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.EntityOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.EntityOption.displayName = 'proto.EntityOption';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.EntityOption.prototype.toObject = function(opt_includeInstance) {
  return proto.EntityOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EntityOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.EntityOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    kind: jspb.Message.getFieldWithDefault(msg, 1, 0),
    visibility: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EntityOption}
 */
proto.EntityOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.EntityOption;
  return proto.EntityOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EntityOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EntityOption}
 */
proto.EntityOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.EntityOption.Kind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 2:
      var value = /** @type {!proto.EntityOption.Visibility} */ (reader.readEnum());
      msg.setVisibility(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.EntityOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.EntityOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EntityOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.EntityOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.EntityOption.Kind = {
  KIND_UNKNOWN: 0,
  AGGREGATE: 1,
  PROJECTION: 2,
  PROCESS_MANAGER: 3,
  ENTITY: 4
};

/**
 * @enum {number}
 */
proto.EntityOption.Visibility = {
  VISIBILITY_UNKNOWN: 0,
  NONE: 1,
  SUBSCRIBE: 2,
  QUERY: 3,
  FULL: 4
};

/**
 * optional Kind kind = 1;
 * @return {!proto.EntityOption.Kind}
 */
proto.EntityOption.prototype.getKind = function() {
  return /** @type {!proto.EntityOption.Kind} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.EntityOption.Kind} value */
proto.EntityOption.prototype.setKind = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Visibility visibility = 2;
 * @return {!proto.EntityOption.Visibility}
 */
proto.EntityOption.prototype.getVisibility = function() {
  return /** @type {!proto.EntityOption.Visibility} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.EntityOption.Visibility} value */
proto.EntityOption.prototype.setVisibility = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.Time = {
  TIME_UNDEFINED: 0,
  PAST: 1,
  FUTURE: 2
};


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `required`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.required = new jspb.ExtensionFieldInfo(
    73812,
    {required: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[73812] = new jspb.ExtensionFieldBinaryInfo(
    proto.required,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[73812] = proto.required;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `ifMissing`.
 * @type {!jspb.ExtensionFieldInfo<!proto.IfMissingOption>}
 */
proto.ifMissing = new jspb.ExtensionFieldInfo(
    73813,
    {ifMissing: 0},
    proto.IfMissingOption,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         proto.IfMissingOption.toObject),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[73813] = new jspb.ExtensionFieldBinaryInfo(
    proto.ifMissing,
    jspb.BinaryReader.prototype.readMessage,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.IfMissingOption.serializeBinaryToWriter,
    proto.IfMissingOption.deserializeBinaryFromReader,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[73813] = proto.ifMissing;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `decimalMax`.
 * @type {!jspb.ExtensionFieldInfo<!proto.DecimalMaxOption>}
 */
proto.decimalMax = new jspb.ExtensionFieldInfo(
    73814,
    {decimalMax: 0},
    proto.DecimalMaxOption,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         proto.DecimalMaxOption.toObject),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[73814] = new jspb.ExtensionFieldBinaryInfo(
    proto.decimalMax,
    jspb.BinaryReader.prototype.readMessage,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.DecimalMaxOption.serializeBinaryToWriter,
    proto.DecimalMaxOption.deserializeBinaryFromReader,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[73814] = proto.decimalMax;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `decimalMin`.
 * @type {!jspb.ExtensionFieldInfo<!proto.DecimalMinOption>}
 */
proto.decimalMin = new jspb.ExtensionFieldInfo(
    73815,
    {decimalMin: 0},
    proto.DecimalMinOption,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         proto.DecimalMinOption.toObject),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[73815] = new jspb.ExtensionFieldBinaryInfo(
    proto.decimalMin,
    jspb.BinaryReader.prototype.readMessage,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.DecimalMinOption.serializeBinaryToWriter,
    proto.DecimalMinOption.deserializeBinaryFromReader,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[73815] = proto.decimalMin;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `max`.
 * @type {!jspb.ExtensionFieldInfo<!proto.MaxOption>}
 */
proto.max = new jspb.ExtensionFieldInfo(
    73816,
    {max: 0},
    proto.MaxOption,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         proto.MaxOption.toObject),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[73816] = new jspb.ExtensionFieldBinaryInfo(
    proto.max,
    jspb.BinaryReader.prototype.readMessage,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.MaxOption.serializeBinaryToWriter,
    proto.MaxOption.deserializeBinaryFromReader,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[73816] = proto.max;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `min`.
 * @type {!jspb.ExtensionFieldInfo<!proto.MinOption>}
 */
proto.min = new jspb.ExtensionFieldInfo(
    73817,
    {min: 0},
    proto.MinOption,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         proto.MinOption.toObject),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[73817] = new jspb.ExtensionFieldBinaryInfo(
    proto.min,
    jspb.BinaryReader.prototype.readMessage,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.MinOption.serializeBinaryToWriter,
    proto.MinOption.deserializeBinaryFromReader,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[73817] = proto.min;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `digits`.
 * @type {!jspb.ExtensionFieldInfo<!proto.DigitsOption>}
 */
proto.digits = new jspb.ExtensionFieldInfo(
    73818,
    {digits: 0},
    proto.DigitsOption,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         proto.DigitsOption.toObject),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[73818] = new jspb.ExtensionFieldBinaryInfo(
    proto.digits,
    jspb.BinaryReader.prototype.readMessage,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.DigitsOption.serializeBinaryToWriter,
    proto.DigitsOption.deserializeBinaryFromReader,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[73818] = proto.digits;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `when`.
 * @type {!jspb.ExtensionFieldInfo<!proto.TimeOption>}
 */
proto.when = new jspb.ExtensionFieldInfo(
    73819,
    {when: 0},
    proto.TimeOption,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         proto.TimeOption.toObject),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[73819] = new jspb.ExtensionFieldBinaryInfo(
    proto.when,
    jspb.BinaryReader.prototype.readMessage,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.TimeOption.serializeBinaryToWriter,
    proto.TimeOption.deserializeBinaryFromReader,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[73819] = proto.when;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `pattern`.
 * @type {!jspb.ExtensionFieldInfo<!proto.PatternOption>}
 */
proto.pattern = new jspb.ExtensionFieldInfo(
    73820,
    {pattern: 0},
    proto.PatternOption,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         proto.PatternOption.toObject),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[73820] = new jspb.ExtensionFieldBinaryInfo(
    proto.pattern,
    jspb.BinaryReader.prototype.readMessage,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.PatternOption.serializeBinaryToWriter,
    proto.PatternOption.deserializeBinaryFromReader,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[73820] = proto.pattern;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `valid`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.valid = new jspb.ExtensionFieldInfo(
    73821,
    {valid: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[73821] = new jspb.ExtensionFieldBinaryInfo(
    proto.valid,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[73821] = proto.valid;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `ifInvalid`.
 * @type {!jspb.ExtensionFieldInfo<!proto.IfInvalidOption>}
 */
proto.ifInvalid = new jspb.ExtensionFieldInfo(
    73822,
    {ifInvalid: 0},
    proto.IfInvalidOption,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         proto.IfInvalidOption.toObject),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[73822] = new jspb.ExtensionFieldBinaryInfo(
    proto.ifInvalid,
    jspb.BinaryReader.prototype.readMessage,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.IfInvalidOption.serializeBinaryToWriter,
    proto.IfInvalidOption.deserializeBinaryFromReader,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[73822] = proto.ifInvalid;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `goes`.
 * @type {!jspb.ExtensionFieldInfo<!proto.GoesOption>}
 */
proto.goes = new jspb.ExtensionFieldInfo(
    73823,
    {goes: 0},
    proto.GoesOption,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         proto.GoesOption.toObject),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[73823] = new jspb.ExtensionFieldBinaryInfo(
    proto.goes,
    jspb.BinaryReader.prototype.readMessage,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.GoesOption.serializeBinaryToWriter,
    proto.GoesOption.deserializeBinaryFromReader,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[73823] = proto.goes;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `internal`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.internal = new jspb.ExtensionFieldInfo(
    73850,
    {internal: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[73850] = new jspb.ExtensionFieldBinaryInfo(
    proto.internal,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[73850] = proto.internal;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `spi`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.spi = new jspb.ExtensionFieldInfo(
    73851,
    {spi: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[73851] = new jspb.ExtensionFieldBinaryInfo(
    proto.spi,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[73851] = proto.spi;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `experimental`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.experimental = new jspb.ExtensionFieldInfo(
    73852,
    {experimental: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[73852] = new jspb.ExtensionFieldBinaryInfo(
    proto.experimental,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[73852] = proto.experimental;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `beta`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.beta = new jspb.ExtensionFieldInfo(
    73853,
    {beta: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[73853] = new jspb.ExtensionFieldBinaryInfo(
    proto.beta,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[73853] = proto.beta;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `by`.
 * @type {!jspb.ExtensionFieldInfo<string>}
 */
proto.by = new jspb.ExtensionFieldInfo(
    73900,
    {by: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[73900] = new jspb.ExtensionFieldBinaryInfo(
    proto.by,
    jspb.BinaryReader.prototype.readString,
    jspb.BinaryWriter.prototype.writeString,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[73900] = proto.by;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `defaultMessage`.
 * @type {!jspb.ExtensionFieldInfo<string>}
 */
proto.defaultMessage = new jspb.ExtensionFieldInfo(
    73901,
    {defaultMessage: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.MessageOptions.extensionsBinary[73901] = new jspb.ExtensionFieldBinaryInfo(
    proto.defaultMessage,
    jspb.BinaryReader.prototype.readString,
    jspb.BinaryWriter.prototype.writeString,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MessageOptions.extensions[73901] = proto.defaultMessage;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `requiredField`.
 * @type {!jspb.ExtensionFieldInfo<string>}
 */
proto.requiredField = new jspb.ExtensionFieldInfo(
    73902,
    {requiredField: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.MessageOptions.extensionsBinary[73902] = new jspb.ExtensionFieldBinaryInfo(
    proto.requiredField,
    jspb.BinaryReader.prototype.readString,
    jspb.BinaryWriter.prototype.writeString,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MessageOptions.extensions[73902] = proto.requiredField;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `entity`.
 * @type {!jspb.ExtensionFieldInfo<!proto.EntityOption>}
 */
proto.entity = new jspb.ExtensionFieldInfo(
    73903,
    {entity: 0},
    proto.EntityOption,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         proto.EntityOption.toObject),
    0);

google_protobuf_descriptor_pb.MessageOptions.extensionsBinary[73903] = new jspb.ExtensionFieldBinaryInfo(
    proto.entity,
    jspb.BinaryReader.prototype.readMessage,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.EntityOption.serializeBinaryToWriter,
    proto.EntityOption.deserializeBinaryFromReader,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MessageOptions.extensions[73903] = proto.entity;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `validationOf`.
 * @type {!jspb.ExtensionFieldInfo<string>}
 */
proto.validationOf = new jspb.ExtensionFieldInfo(
    73904,
    {validationOf: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.MessageOptions.extensionsBinary[73904] = new jspb.ExtensionFieldBinaryInfo(
    proto.validationOf,
    jspb.BinaryReader.prototype.readString,
    jspb.BinaryWriter.prototype.writeString,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MessageOptions.extensions[73904] = proto.validationOf;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `internalType`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.internalType = new jspb.ExtensionFieldInfo(
    73911,
    {internalType: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.MessageOptions.extensionsBinary[73911] = new jspb.ExtensionFieldBinaryInfo(
    proto.internalType,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MessageOptions.extensions[73911] = proto.internalType;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `spiType`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.spiType = new jspb.ExtensionFieldInfo(
    73912,
    {spiType: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.MessageOptions.extensionsBinary[73912] = new jspb.ExtensionFieldBinaryInfo(
    proto.spiType,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MessageOptions.extensions[73912] = proto.spiType;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `experimentalType`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.experimentalType = new jspb.ExtensionFieldInfo(
    73913,
    {experimentalType: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.MessageOptions.extensionsBinary[73913] = new jspb.ExtensionFieldBinaryInfo(
    proto.experimentalType,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MessageOptions.extensions[73913] = proto.experimentalType;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `betaType`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.betaType = new jspb.ExtensionFieldInfo(
    73914,
    {betaType: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.MessageOptions.extensionsBinary[73914] = new jspb.ExtensionFieldBinaryInfo(
    proto.betaType,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MessageOptions.extensions[73914] = proto.betaType;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `is`.
 * @type {!jspb.ExtensionFieldInfo<string>}
 */
proto.is = new jspb.ExtensionFieldInfo(
    73915,
    {is: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.MessageOptions.extensionsBinary[73915] = new jspb.ExtensionFieldBinaryInfo(
    proto.is,
    jspb.BinaryReader.prototype.readString,
    jspb.BinaryWriter.prototype.writeString,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MessageOptions.extensions[73915] = proto.is;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `enrichmentFor`.
 * @type {!jspb.ExtensionFieldInfo<string>}
 */
proto.enrichmentFor = new jspb.ExtensionFieldInfo(
    73922,
    {enrichmentFor: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.MessageOptions.extensionsBinary[73922] = new jspb.ExtensionFieldBinaryInfo(
    proto.enrichmentFor,
    jspb.BinaryReader.prototype.readString,
    jspb.BinaryWriter.prototype.writeString,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MessageOptions.extensions[73922] = proto.enrichmentFor;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `enrichment`.
 * @type {!jspb.ExtensionFieldInfo<string>}
 */
proto.enrichment = new jspb.ExtensionFieldInfo(
    73923,
    {enrichment: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.MessageOptions.extensionsBinary[73923] = new jspb.ExtensionFieldBinaryInfo(
    proto.enrichment,
    jspb.BinaryReader.prototype.readString,
    jspb.BinaryWriter.prototype.writeString,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MessageOptions.extensions[73923] = proto.enrichment;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `events`.
 * @type {!jspb.ExtensionFieldInfo<string>}
 */
proto.events = new jspb.ExtensionFieldInfo(
    73939,
    {events: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.MessageOptions.extensionsBinary[73939] = new jspb.ExtensionFieldBinaryInfo(
    proto.events,
    jspb.BinaryReader.prototype.readString,
    jspb.BinaryWriter.prototype.writeString,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MessageOptions.extensions[73939] = proto.events;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `rejections`.
 * @type {!jspb.ExtensionFieldInfo<string>}
 */
proto.rejections = new jspb.ExtensionFieldInfo(
    73940,
    {rejections: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.MessageOptions.extensionsBinary[73940] = new jspb.ExtensionFieldBinaryInfo(
    proto.rejections,
    jspb.BinaryReader.prototype.readString,
    jspb.BinaryWriter.prototype.writeString,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MessageOptions.extensions[73940] = proto.rejections;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `typeUrlPrefix`.
 * @type {!jspb.ExtensionFieldInfo<string>}
 */
proto.typeUrlPrefix = new jspb.ExtensionFieldInfo(
    73941,
    {typeUrlPrefix: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FileOptions.extensionsBinary[73941] = new jspb.ExtensionFieldBinaryInfo(
    proto.typeUrlPrefix,
    jspb.BinaryReader.prototype.readString,
    jspb.BinaryWriter.prototype.writeString,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FileOptions.extensions[73941] = proto.typeUrlPrefix;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `internalAll`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.internalAll = new jspb.ExtensionFieldInfo(
    73942,
    {internalAll: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FileOptions.extensionsBinary[73942] = new jspb.ExtensionFieldBinaryInfo(
    proto.internalAll,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FileOptions.extensions[73942] = proto.internalAll;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `spiAll`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.spiAll = new jspb.ExtensionFieldInfo(
    73943,
    {spiAll: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FileOptions.extensionsBinary[73943] = new jspb.ExtensionFieldBinaryInfo(
    proto.spiAll,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FileOptions.extensions[73943] = proto.spiAll;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `experimentalAll`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.experimentalAll = new jspb.ExtensionFieldInfo(
    73944,
    {experimentalAll: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FileOptions.extensionsBinary[73944] = new jspb.ExtensionFieldBinaryInfo(
    proto.experimentalAll,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FileOptions.extensions[73944] = proto.experimentalAll;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `betaAll`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.betaAll = new jspb.ExtensionFieldInfo(
    73945,
    {betaAll: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FileOptions.extensionsBinary[73945] = new jspb.ExtensionFieldBinaryInfo(
    proto.betaAll,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FileOptions.extensions[73945] = proto.betaAll;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `everyIs`.
 * @type {!jspb.ExtensionFieldInfo<string>}
 */
proto.everyIs = new jspb.ExtensionFieldInfo(
    73946,
    {everyIs: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FileOptions.extensionsBinary[73946] = new jspb.ExtensionFieldBinaryInfo(
    proto.everyIs,
    jspb.BinaryReader.prototype.readString,
    jspb.BinaryWriter.prototype.writeString,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FileOptions.extensions[73946] = proto.everyIs;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `spiService`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.spiService = new jspb.ExtensionFieldInfo(
    73971,
    {spiService: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.ServiceOptions.extensionsBinary[73971] = new jspb.ExtensionFieldBinaryInfo(
    proto.spiService,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.ServiceOptions.extensions[73971] = proto.spiService;

goog.object.extend(exports, proto);
